import React from 'react';

import { Icon } from '../Icon';
import * as S from './link.styles';
import { LinkProps } from './link.types';

export const Link: React.FC<LinkProps> = ({
  onClick,
  text,
  isDisabled,
  isBlocked,
  look = 'positive',
  icon,
  iconPos = 'right',
}) => {
  return (
    <S.Container
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        !isBlocked && onClick(e);
      }}
      $isDisabled={isDisabled}
      $isBlocked={isBlocked}
      $look={look}
    >
      {icon && iconPos === 'left' && (
        <S.IconContainer>
          <Icon icon={icon} />
        </S.IconContainer>
      )}
      <S.Link>{text}</S.Link>
      {icon && iconPos === 'right' && (
        <S.IconContainer>
          <Icon icon={icon} />
        </S.IconContainer>
      )}
    </S.Container>
  );
};
